<template>
  <div class="profile" v-if="charge">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
    >
      <v-tab>Datos básicos</v-tab>
      <v-tab>Perfil</v-tab>
      <v-tab>Tipos de actividades</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Nombre:</span>
                {{ charge.name }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Crear Informe?:</span
                >
                {{ charge.can_create_report ? "SI" : "NO" }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Editar Informe?:</span
                >
                {{ charge.can_reviewer_report ? "SI" : "NO" }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Agregar Estadisticas?:</span
                >
                {{ charge.can_add_statistics ? "SI" : "NO" }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Agregar Logros?:</span
                >
                {{ charge.can_add_achievements ? "SI" : "NO" }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Puede Agregar Acompañamientos?:</span
                >
                {{ charge.can_add_accompaniments ? "SI" : "NO" }}
              </v-col>           
              <v-col cols="12" md="12">
                <span class="black--text font-weight-bold"
                  >Texto de ayuda:</span
                >
                {{ charge.help_text }}
              </v-col>
              <v-col cols="12" md="3">
                <v-chip
                  :color="getEmployeeStatuColor(charge.status)"
                  dark
                  small
                >
                  {{ getEmployeeStatus(charge.status) }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="charge.annexes"
          class="elevation-1 mb-7 mt-6"
          no-data-text="No hay registros agregados..."
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Anexos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class="mb-2" @click="addAnnexe">
                Agregar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="item">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="editAnnexe(item.item)"
                >
                  <v-icon dark> mdi-circle-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteAnnexe(item.item)"
                >
                  <v-icon dark> mdi-delete </v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="headersTypeActivities"
          :items="charge.type_activities"
          class="elevation-1 mb-7 mt-6"
          no-data-text="No hay registros agregados..."
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Tipos de actividades</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class="mb-2" @click="addTypeActivity">
                Agregar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.status`]="item">
            <v-chip :color="getEmployeeStatuColor(item.item.status)" dark small>
              {{ getEmployeeStatus(item.item.status) }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="item">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="editTypeActivity(item.item)"
                >
                  <v-icon dark> mdi-circle-edit-outline </v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :color="item.item.status == 'ACTIVE' ? 'red' : 'green'"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteTypeActivity(item.item)"
                >
                  <v-icon dark>
                    {{
                      item.item.status == "ACTIVE"
                        ? "mdi-close-circle-outline"
                        : "mdi-check"
                    }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                item.item.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR"
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <!-- Dialog edit annexe -->
    <v-dialog v-model="dialogAnnexe" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ titleDialogAnnexe }} Anexo</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formAnnexe" v-model="formEditAnnexe">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="modelAnnexe.name"
                    label="Nombre"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="modelAnnexe.value"
                    label="Descripción"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeAnnexe">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveAnnexe">
            {{ titleDialogAnnexe }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteAnnexe" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Seguro que desea eliminar este anexo?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteAnnexe"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteAnnexeConfirm"
            >Aceptar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog edit type activity -->
    <v-dialog v-model="dialogTypeActivity" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ titleDialogTypeActivity }} Tipo de actividad</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formAnnexe" v-model="formEditTypeActivity">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="modelTypeActivity.name"
                    label="Nombre"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeTypeActivity">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveTypeActivity">
            {{ titleDialogTypeActivity }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteTypeActivity" max-width="500px">
      <v-card v-if="currentTypeActivity" class="text-center">
        <v-card-title class="headline text-center"
          >Seguro que desea
          <b>{{
            currentTypeActivity.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR"
          }}</b>
          del tipo de actividad - {{ currentTypeActivity.name }}?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteTypeActivity"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteTypeActivityConfirm"
            >Aceptar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_ALERT } from "@/store/alert";
import { SET_CHARGE } from "@/store/charge";
export default {
  name: "ShowCharge",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  data: () => ({
    tab: null,
    charge: null,
    formEditAnnexe: true,
    dialogAnnexe: false,
    currentAnnexe: null,
    dialogDeleteAnnexe: false,
    modelAnnexe: {
      name: "",
      value: "",
    },
    formEditTypeActivity: true,
    dialogTypeActivity: false,
    currentTypeActivity: null,
    dialogDeleteTypeActivity: false,
    modelTypeActivity: {
      name: "",
    },
    headers: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Descripción", value: "value", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
    headersTypeActivities: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Estado", value: "status", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
  }),
  created() {
    this.$store.dispatch("getCharge", this.$route.params.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CHARGE) {
        this.charge = state.charge.charge;
      }
    });
  },
  computed: {
    ...mapGetters(["getEmployeeStatus", "getEmployeeStatuColor"]),
    titleDialogAnnexe() {
      return this.currentAnnexe ? "Editar" : "Agregar";
    },
    titleDialogTypeActivity() {
      return this.currentTypeActivity ? "Editar" : "Agregar";
    },
  },
  methods: {
    addAnnexe() {
      this.dialogAnnexe = true;
    },
    editAnnexe(item) {
      this.currentAnnexe = item;
      this.modelAnnexe = {
        name: item.name,
        value: item.value,
      };
      this.dialogAnnexe = true;
    },
    deleteAnnexe(item) {
      this.currentAnnexe = item;
      this.dialogDeleteAnnexe = true;
    },
    closeAnnexe() {
      this.dialogAnnexe = false;
      this.$nextTick(() => {
        this.currentAnnexe = null;
        this.modelAnnexe = {
          name: "",
          value: "",
        };
      });
    },
    saveAnnexe() {
      if (this.modelAnnexe.name == "" || this.modelAnnexe.value == "") {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }

      if (this.currentAnnexe) {
        this.$store.dispatch("updateAnnexe", {
          id: this.currentAnnexe.id,
          form: this.modelAnnexe,
        });
      } else {
        this.modelAnnexe.charge_id = this.charge.id;
        this.$store.dispatch("createAnnexe", this.modelAnnexe);
        delete this.modelAnnexe.charge_id;
      }
      this.closeAnnexe();
    },
    deleteAnnexeConfirm() {
      this.$store.dispatch("deleteAnnexe", this.currentAnnexe.id);
      this.closeDeleteAnnexe();
    },
    closeDeleteAnnexe() {
      this.dialogDeleteAnnexe = false;
      this.currentAnnexe = null;
    },
    addTypeActivity() {
      this.dialogTypeActivity = true;
    },
    editTypeActivity(item) {
      this.currentTypeActivity = item;
      this.modelTypeActivity = {
        name: item.name,
      };
      this.dialogTypeActivity = true;
    },
    deleteTypeActivity(item) {
      this.currentTypeActivity = item;
      this.dialogDeleteTypeActivity = true;
    },
    closeTypeActivity() {
      this.dialogTypeActivity = false;
      this.$nextTick(() => {
        this.currentTypeActivity = null;
        this.modelTypeActivity = {
          name: "",
        };
      });
    },
    saveTypeActivity() {
      if (this.modelTypeActivity.name == "") {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }

      if (this.currentTypeActivity) {
        this.$store.dispatch("updateTypeActivity", {
          id: this.currentTypeActivity.id,
          form: this.modelTypeActivity,
        });
      } else {
        this.modelTypeActivity.charge_id = this.charge.id;
        this.$store.dispatch("createTypeActivity", this.modelTypeActivity);
        delete this.modelTypeActivity.charge_id;
      }
      this.closeTypeActivity();
    },
    deleteTypeActivityConfirm() {
      this.$store.dispatch("updateTypeActivity", {
        id: this.currentTypeActivity.id,
        form: {
          status:
            this.currentTypeActivity.status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
        },
      });
      this.closeDeleteTypeActivity();
    },
    closeDeleteTypeActivity() {
      this.dialogDeleteTypeActivity = false;
      this.currentTypeActivity = null;
    },
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
